class Filter {
    id: KnockoutObservable<string>;
    animate: KnockoutObservable<boolean>;
    boundField: KnockoutObservable<number>;
    boundFieldType: KnockoutObservable<DataTypeEnum>;
    dynamicParameter: KnockoutObservable<boolean>;
    dynamicParameterName: KnockoutObservable<string>;
    conditionType: KnockoutObservable<FilterConditionTypeEnum>;
    dataSourceLength: KnockoutObservable<number>;
    dateRange: KnockoutObservable<number>;
    displayField: KnockoutObservable<number>;
    displayFieldType: KnockoutObservable<DataTypeEnum>;
    displayBoundFieldName: KnockoutObservable<string>;
    displayDisplayFieldName: KnockoutObservable<string>;
    endCondition: KnockoutObservable<string>;
    filterEditorType: KnockoutObservable<FilterEditorTypeEnum>;
    filterName: KnockoutComputed<string>;
    private _filterName: KnockoutObservable<string>;
    customFilterName: KnockoutObservable<string>;
    filterTemplate: KnockoutObservable<number>;
    isDrilldown: KnockoutObservable<boolean>;

    metricFilterAbsolute: KnockoutObservable<boolean>;
    metricId: KnockoutObservable<number>;
    modifier: KnockoutObservable<FilterModifiersEnum>;
    multipleCondition: KnockoutObservable<Array<string>>;
    preserveDrillDownFromWidget: KnockoutObservable<boolean>;
    readOnly: KnockoutObservable<boolean>;
    scope: KnockoutObservable<ContainerScopeEnum>;
    scopeAction: KnockoutObservable<ScopeActionEnum>;
    showFilter: KnockoutObservable<boolean>;
    startCondition: KnockoutObservable<string>;
    startDisplayCondition: KnockoutObservable<string>;
    switchChecked: KnockoutObservable<boolean>;
    switchFalseLabel: KnockoutObservable<string>;
    switchTrueLabel: KnockoutObservable<string>;
    switchTrueValue: KnockoutObservableArray<any>;
    switchFalseValue: KnockoutObservableArray<any>;
    visibleFields: KnockoutObservable<Array<number>>;
    isComparisonFilter: KnockoutObservable<boolean>;
    isDirty: KnockoutObservable<boolean>;
    sortField: KnockoutObservable<DefinedFieldEnum>;

    dateRangeConfig: DateRangeConfigFilter;
    //dataSource: Array<Array<object>>;
    dataSource: KnockoutObservableArray<Array<object>>;
    requireDataSourceUpdate: KnockoutObservable<boolean>;
    isMetric: KnockoutComputed<boolean>;
    showForDrilldown: KnockoutObservable<boolean>;
    metricQueryName: KnockoutObservable<string>;

    startEndDateRangeTmp: KnockoutObservableArray<string>;

    showNullButton: KnockoutObservable<boolean>;

    /** flag to indicate that the filter has been removed*/
    removed: KnockoutObservable<boolean>;
    /** flag to indicate that the filter has been added*/
    added: KnockoutObservable<boolean>;

    previousDateClick: Function;
    nextDateClick: Function;
    clearFilter: Function;
    updateDataSource: Function;
    customPublish: Function;
    onContentReady: () => void;
    beforeApplyFilter: () => void;

    /** return filter component like dxDateBox or dxDateRangeBox, for other components it is necessary to implement it */
    getComponent: () => any;

    constructor(data, dataSource = undefined) {
        this.id = ko.observable(data.id);
        this.animate = ko.observable(data.animate);
        this.boundField = ko.observable(data.boundField);
        this.boundFieldType = ko.observable(data.boundFieldType);
        this.dynamicParameter = ko.observable(data.dynamicParameter);
        this.dynamicParameterName = ko.observable(data.dynamicParameterName);

        this.conditionType = ko.observable(data.conditionType);
        this.dataSourceLength = ko.observable(data.dataSourceLength);
        this.dateRange = ko.observable(data.dateRange);
        this.displayField = ko.observable(data.displayField);

        this.displayFieldType = ko.observable(data.displayFieldType);
        this.displayBoundFieldName = ko.observable(data.displayBoundFieldName);
        this.displayDisplayFieldName = ko.observable(data.displayDisplayFieldName);
        this.endCondition = ko.observable(data.endCondition);

        this.filterEditorType = ko.observable(data.filterEditorType);

        this._filterName = ko.observable(data.filterName);
        this.filterName = ko.pureComputed({
            read: function (this: Filter) {
                let filterName = this._filterName();
                if (this.customFilterName()) {
                    filterName = this.customFilterName();
                }

                filterName = replaceBasicHtmlContent(filterName);
                return filterName;
            },
            write: function (this: Filter, value: string) {
                this._filterName(value);
            },
            owner: this
        });
        this.customFilterName = ko.observable(data.customFilterName);

        this.filterTemplate = ko.observable(data.filterTemplate);
        this.isDrilldown = ko.observable(data.isDrilldown);

        this.metricFilterAbsolute = ko.observable(data.metricFilterAbsolute);
        this.metricId = ko.observable(data.metricId);
        this.modifier = ko.observable(data.modifier);
        this.multipleCondition = ko.observable(data.multipleCondition);

        this.preserveDrillDownFromWidget = ko.observable(data.preserveDrillDownFromWidget);
        this.readOnly = ko.observable(data.readOnly);
        this.scope = ko.observable(data.scope);
        this.scopeAction = ko.observable(data.scopeAction);

        this.showFilter = ko.observable(data.showFilter);
        this.startCondition = ko.observable(data.startCondition);
        this.startDisplayCondition = ko.observable(data.startDisplayCondition);
        this.switchChecked = ko.observable(data.switchChecked);

        this.switchFalseLabel = ko.observable(data.switchFalseLabel);
        this.switchTrueLabel = ko.observable(data.switchTrueLabel);
        this.switchTrueValue = ko.observableArray(data.switchTrueValue);
        this.switchFalseValue = ko.observableArray(data.switchFalseValue);
        this.visibleFields = ko.observable(data.visibleFields);
        this.isComparisonFilter = ko.observable(data.isComparisonFilter);
        this.isDirty = ko.observable(false);
        this.sortField = ko.observable(data.sortField);

        this.dateRangeConfig = new DateRangeConfigFilter(data.dateRangeConfig);
        this.dataSource = ko.observableArray(dataSource !== undefined ? dataSource : []);
        this.requireDataSourceUpdate = ko.observable(dataSource !== undefined ? false : true);
        this.metricQueryName = ko.observable(data.metricQueryName);

        this.showForDrilldown = ko.observable(data.showForDrilldown);

        this.removed = ko.observable(false);
        this.added = ko.observable(false);

        if (this.requireDataSourceUpdate()) {
            //As the datasource is only loaded later, I need to create the datasource for the devexpress grid to work
            if (this.filterEditorType() === FilterEditorTypeEnum.ValuesCombo) {
                let row = { 0: this.startCondition(), 1: this.startCondition() } as any;
                this.dataSource().push(row);
                this.multipleCondition([this.startCondition()]);
            }
            else {
                let rows = [];
                (this.multipleCondition() || []).forEach(function (value) {
                    rows.push({ 0: value, 1: value });
                });
                this.dataSource(rows);
            }
            //*****
        }

        if (this.filterEditorType() === FilterEditorTypeEnum.DateRange) {
            this.startEndDateRangeTmp = ko.observableArray();
        }

        this.isMetric = ko.computed(function () { return this.metricId() !== null && this.metricId() !== undefined && this.metricId() !== 0; }.bind(this));
        this.showNullButton = ko.observable(true);
    }

    get isInNotInFilter() {
        return this.filterEditorType() === FilterEditorTypeEnum.AutoComplete || this.filterEditorType() === FilterEditorTypeEnum.MultiSelect;
    }

    getConditionTypeOptions(): Array<object> {
        let self = this;

        return [
            {
                id: FilterConditionTypeEnum.Equals, text: "Equals", icon: "&equals;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.Date || editorType === FilterEditorTypeEnum.TextBox ||
                        editorType === FilterEditorTypeEnum.Quarter || editorType === FilterEditorTypeEnum.Numeric ||
                        editorType === FilterEditorTypeEnum.Month || editorType === FilterEditorTypeEnum.ValuesCombo ||
                        editorType === FilterEditorTypeEnum.Week;
                }
            },
            {
                id: FilterConditionTypeEnum.Different, text: "Different", icon: "&ne;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.Date || editorType === FilterEditorTypeEnum.TextBox ||
                        editorType === FilterEditorTypeEnum.Quarter || editorType === FilterEditorTypeEnum.Numeric ||
                        editorType === FilterEditorTypeEnum.Month || editorType === FilterEditorTypeEnum.ValuesCombo ||
                        editorType === FilterEditorTypeEnum.Week;
                }
            },
            {
                id: FilterConditionTypeEnum.In, text: "In", icon: null,
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.AutoComplete || editorType === FilterEditorTypeEnum.MultiSelect;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.NotIn, text: "Not In", icon: null,
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.AutoComplete || editorType === FilterEditorTypeEnum.MultiSelect;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.Between, text: "Between", icon: "&ge; &leq;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.DateRange ||
                        isMetric;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.NotBetween, text: "Not Between", icon: "&leq; &ge;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.DateRange ||
                        isMetric;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.GreaterThan, text: "Greater Than", icon: "&gt;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return isMetric;
                }.bind(this)
            },            
            {
                id: FilterConditionTypeEnum.EqualsOrGreaterThan, text: "Greater Than or Equals", icon: "&ge;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return isMetric;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.LessThan, text: "Less Than", icon: "&lt;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return isMetric;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.EqualsOrLessThan, text: "Less Than or Equals", icon: "&leq;",
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return isMetric;
                }.bind(this)
            },
            {
                id: FilterConditionTypeEnum.Contains, text: "Contains", icon: null,
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.TextBox && self.startCondition() !== null;
                }.bind(this)
            }, {
                id: FilterConditionTypeEnum.StartsWith, text: "Starts with", icon: null,
                visible: function (editorType: FilterEditorTypeEnum, isMetric: boolean) {
                    return editorType === FilterEditorTypeEnum.TextBox && self.startCondition() !== null;
                }.bind(this)
            },
        ];
    }

    publish() {
        if (this.customPublish) {
            this.customPublish();
            return;
        }

        if (this.isComparisonFilter && this.isComparisonFilter()) {
            return;
        }

        this.isDirty(true);

        if (!this.isDrilldown()) {
            workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
        }
    }

    nextPreviousDateChange(isNextDate: boolean, dateRanges: Array<DateRange>, element: JQuery<HTMLElement>, isWidgetFilter: boolean) {
        let self = this;
        let type = isNextDate ? "nextdate" : "previousdate";

        let dateRange = dateRanges.find(function (x) { return x.id() === this.dateRange(); }.bind(this));
        let newDateRangeId = 0;
        if (isNextDate) {
            newDateRangeId = dateRange.nextDate();
        }
        else {
            newDateRangeId = dateRange.previousDate();
        }

        if (newDateRangeId !== 0) {
            let hasNewDateRange = dateRanges.find(function (x) { return x.id() === newDateRangeId; }) !== undefined;
            if (!hasNewDateRange) {
                newDateRangeId = 0;
            }
        }

        let lastDateRangeUsed;
        if (this.dateRangeConfig.userDates()) {
            lastDateRangeUsed = null;
        }
        else if (this.dateRangeConfig.multiplier() == 0) {
            lastDateRangeUsed = this.dateRange();
        }
        else {
            lastDateRangeUsed = this.dateRangeConfig.lastDateUsed();
        }

        if (newDateRangeId === 0) {
            if (isNextDate) {
                this.dateRangeConfig.multiplier(this.dateRangeConfig.multiplier() + 1);
            }
            else {
                this.dateRangeConfig.multiplier(this.dateRangeConfig.multiplier() - 1);
            }

            if (this.dateRangeConfig.multiplier() === 0) {
                newDateRangeId = this.dateRangeConfig.lastDateUsed() || 0;
                this.dateRangeConfig.lastDateUsed(null);
            }
        }

        if (newDateRangeId !== 0) {
            this.dateRange(newDateRangeId);

            if (!isWidgetFilter) {
                if (this.isDrilldown()) {
                    workbook.workbookConfig.filterHelper.updateDrilldownFilters();
                }
                else {
                    workbook.workbookConfig.filterHelper.updateFilters();
                }
            }
        }
        else {
            if (this.dateRangeConfig.startDate() !== null) {
                this.dateRangeConfig.startDate(this.dateRangeConfig.startDate());
            }
            else {
                this.dateRangeConfig.startDate(this.startCondition());
            }

            if (this.dateRangeConfig.endDate() !== null) {
                this.dateRangeConfig.endDate(this.dateRangeConfig.endDate());
            }
            else {
                this.dateRangeConfig.endDate(this.endCondition());
            }

            this.dateRangeConfig.lastDateUsed(lastDateRangeUsed);

            let data = workbook.workbookConfig.activeTab().getBaseSubmitObject();
            $.extend(data, ko.mapping.toJS(this.dateRangeConfig));
            irGlobal.updateFromServer({},
                urlConfigs.tabs + "GetNewDateRange",
                data,
                function (data) {
                    self.dateRange(irGlobal.customDate.custom);

                    let usersDate = self.dateRangeConfig.userDates();
                    let multiplier = self.dateRangeConfig.multiplier();
                    let lastDateUsed = self.dateRangeConfig.lastDateUsed();
                    let startDate = self.dateRangeConfig.startDate();
                    let endDate = self.dateRangeConfig.endDate();

                    if (self.getComponent) {
                        if (self.filterEditorType() == FilterEditorTypeEnum.Date) {
                            (self.getComponent() as DevExpress.ui.dxDateBox).option("value", data.startDate);
                        }
                        else if (self.filterEditorType() == FilterEditorTypeEnum.DateRange) {
                            (self.getComponent() as DevExpress.ui.dxDateRangeBox).option("value", [data.startDate, data.endDate]);
                        }
                    }

                    self.dateRangeConfig.userDates(usersDate);
                    self.dateRangeConfig.multiplier(multiplier);
                    self.dateRangeConfig.lastDateUsed(lastDateUsed);
                    self.dateRangeConfig.startDate(startDate);
                    self.dateRangeConfig.endDate(endDate)

                    if (!isWidgetFilter) {
                        if (self.isDrilldown()) {
                            workbook.workbookConfig.filterHelper.updateDrilldownFilters();
                        }
                        else {
                            workbook.workbookConfig.filterHelper.updateFilters();
                        }
                    }
                },
                function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to get the Date Range";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                },
                true,
                "POST",
                undefined,
                undefined,
                true,
                false);
        }
    }

    isCombinedDate(): boolean {
        return this.scopeAction() === ScopeActionEnum.Combine && (this.filterEditorType() === FilterEditorTypeEnum.Date || this.filterEditorType() === FilterEditorTypeEnum.DateRange);
    }

    remove() {
        let self = this;
        let o = {
            url: urlConfigs.filters + "RemoveFilter",
            data: { workbookId: workbook.workbookConfig.workbookId() },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function () {
            self.removed(true);

            if (!self.isDrilldown()) {
                workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to delete filter";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };
        irGlobal.requestServer(o);
    }

    get conditionTypeIcon() {
        switch (this.conditionType()) {
            case FilterConditionTypeEnum.NotBetween:
            case FilterConditionTypeEnum.NotIn:
            case FilterConditionTypeEnum.Different:
                return " ≠ ";
            case FilterConditionTypeEnum.EqualsOrGreaterThan:
                return " ≥ ";
            case FilterConditionTypeEnum.EqualsOrLessThan:
                return " ≤ ";
            case FilterConditionTypeEnum.GreaterThan:
                return " > ";
            case FilterConditionTypeEnum.LessThan:
                return " < ";
            default:
                return ":";
        }
    }

    static getIcon(filterEditorType: FilterEditorTypeEnum, isMetric: boolean, isIRIcon: boolean = false) {
        let icon = "filter_alt";
        switch (filterEditorType) {
            case FilterEditorTypeEnum.TextBox:
                icon = "font_download";
                break;
            case FilterEditorTypeEnum.Date:
                icon = "calendar_today";
                break;
            case FilterEditorTypeEnum.DateRange:
                icon = "date_range";
                break;
            case FilterEditorTypeEnum.Numeric:
                icon = "looks_one";
                break;
            case FilterEditorTypeEnum.ValuesCombo:
                icon = "smart_button";
                break;
            case FilterEditorTypeEnum.MultiSelect:
            case FilterEditorTypeEnum.AutoComplete:
                icon = "fact_check";
                break;
            case FilterEditorTypeEnum.Month:
                icon = "event_note";
                break;
            case FilterEditorTypeEnum.Quarter:
                icon = "insert_invitation";
                break;
            case FilterEditorTypeEnum.Week:
                icon = "calendar_view_week";
                break;
            default:
                break;
        }

        if (isMetric) {
            icon = "functions";
        }

        if (isIRIcon) {
            icon = `ir-${icon}-icon`;
        }

        return icon;
    }
}